export default __webpack_public_path__ + "static/img/live-popup-bg.574f29a.png";